import { useCallback } from 'react';
import { useApi } from './useApi';

/**
 * Issue reporting from the feedback button.
 *
 * This hook used to also fetch the /updates page contents from GitHub via
 * `changelog-list`. That endpoint and its reader are gone: the page now renders
 * the weekly drafted summaries in `useFeatureDigests`. Only the "report an
 * issue" path, which files a Linear issue (TECH-180), remains here.
 */
export function useChangelog() {
  const { apiCall } = useApi();

  const submitIssue = useCallback(async ({ title, description, type, page }) => {
    const data = await apiCall('changelog-create-issue', {
      method: 'POST',
      body: JSON.stringify({ title, description, type, page }),
    });
    return data;
  }, [apiCall]);

  return { submitIssue };
}
